import { Component, EventEmitter, input, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { Application } from '@softline/application';

import { IconComponent, CardComponent } from '@softline/ui-core';
import { TranslatePipe } from '@softline/ui-core';
@Component({
  selector: 'soft-app-grid',
  templateUrl: './app-grid.component.html',
  styleUrls: ['./app-grid.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [IconComponent, TranslatePipe, CardComponent],
})
export class AppGridComponent {
  @Input() application!: Application;
  @Output() navigate = new EventEmitter<Application>();
  @Output() pinChange = new EventEmitter<boolean>();
  showColor = input(false);
  showMetadata = input(false);
  pinned = input(false);
  canPin = input(true);

  goToApplication(application: Application): void {
    this.navigate.emit(application);
  }

  openInNewTab(application: Application, event: MouseEvent): void {
    event.stopPropagation();
    if (application.type === 'link') {
      if (application.href) window.open(application.href, '_blank');
    } else if (application.route) {
      window.open(window.location.origin + application.route, '_blank');
    }
  }
}
